// @flow

import WebComponent                from 'fg-frontend/src/webComponents/WebComponent';
import { getWebComponentInstance } from 'fg-frontend/src/webComponents/decorate';
import 'element-closest';

type WebActionProps = {
	actionEvent: string,
	actionTarget: string,
}

export default (props: WebActionProps, e: SyntheticEvent<EventTarget>) => {
	const { actionEvent, actionTarget } = props;
	e.preventDefault();

	if ( actionEvent === 'submit' ) {
		if ( !(e.target instanceof HTMLElement) ) return;
		const form = e.target.closest('form');
		if ( form instanceof HTMLFormElement) {
			if ( form.requestSubmit ) {
				form.requestSubmit();
			} else {
				form.submit();
			}
		}
	} else if ( actionEvent === 'click' ) {
		const targetElement = document.querySelector(actionTarget);
		if ( !(targetElement instanceof HTMLElement) ) return;
		targetElement.click();
	} else {
		const element = document.getElementById(actionTarget);
		if ( !(element instanceof HTMLElement) ) return;
		const component = getWebComponentInstance(element);
		if ( !(component instanceof WebComponent) ) return;
		const myEvent = new CustomEvent(actionEvent, { bubbles: true });
		component.dispatchEvent(myEvent);
	}
};



// WEBPACK FOOTER //
// ./fe/web-majetek/src/js/webActions/recall.js